import React, { useEffect } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import TextInput from 'tennders-common/form/components/new-inputs/TextInput'
import Select from 'tennders-common/form/components/new-inputs/Select'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import PercentageInput from 'tennders-common/form/components/new-inputs/PercentageInput'
import useMultipleSalesInvoiceDiscountRow
  from 'tennders-finance/sales-invoice/hooks/useMultipleSalesInvoiceDiscountRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

export const defaultLineForm = {
  concept: 'Discount',
  amount: 0,
  vatPercentage: null,
  value: null,
  applyTo: 'price',
  totalAmount: 0,
  transactionId: null,
  agreedPrice: 0
}

const applyTo = [
  { label: 'Apply To Amount on the Invoice', value: 'price' },
  { label: 'Apply To Amount on the Invoice & Extra Cost', value: 'all' }
]
let prevSelectedPT = null

const MultipleSalesInvoiceDiscountRow = (props) => {
  const {
    keyIndex,
    discountLinesLength,
    costPrice,
    removeLine,
    onFormChange,
    index,
    initialErrors,
    defaultVat,
    isCreditNote,
    editMode,
    selectedPaymentTerm
  } = props

  const {
    errors,
    form,
    setForm,
    onChange
  } = useMultipleSalesInvoiceDiscountRow({
    costPrice,
    onFormChange,
    initialErrors,
    index: keyIndex
  })

  useEffect(() => {
    const f = { ...form }
    if (defaultVat !== null && f?.vatPercentage === null && !editMode) {
      f.vatPercentage = defaultVat
    }
    if (selectedPaymentTerm?.discount && !editMode) {
      f.value = selectedPaymentTerm.discount
      f.concept = (selectedPaymentTerm.type?.code || '') + ' Discount'
      prevSelectedPT = selectedPaymentTerm
    } else if (!editMode && prevSelectedPT?.discount === f.value) {
      f.value = null
      f.concept = ''
    }
    setForm(f)
  }, [defaultVat, selectedPaymentTerm])

  return (
    <tr>
      <td>
        <GHref
          className="cursor-pointer link-mid-gray"
          disabled={discountLinesLength <= 1}
          onClick={() => removeLine(keyIndex)}
        >
          <FontAwesomeIcon icon={faXmark} fontSize={20} />
        </GHref>
      </td>
      <td>
        {index + 1}
      </td>
      <td colSpan={2}>
        <Select
          placeholder="Apply to"
          value={form.applyTo}
          items={applyTo}
          onSet={(value) => onChange('applyTo', value)}
          style={{ minWidth: '100px' }}
          className="form-select smaller" />
      </td>
      <td>
        <TextInput
          className="form-input smaller"
          value={form.concept}
          error={errors.concept}
          onSet={(value) => onChange('concept', value)} />
      </td>
      <td>
        <PercentageInput
          allowNegativeValue={false}
          className="form-input smaller"
          onSet={(value) => onChange('value', value)}
          placeholder="0%"
          value={form.value || null}
          error={errors.value} />
      </td>
      <td>
        <CurrencyInput
          disabled
          allowNegativeValue={false}
          className="form-input smaller disabled"
          placeholder="amount"
          value={form.amount}
          error={errors.amount} />
      </td>
      <td>
        <PercentageInput
          className="form-input smaller"
          onSet={(value) => onChange('vatPercentage', value)}
          placeholder="0%"
          value={form.vatPercentage || null}
          error={errors.vatPercentage} />
      </td>
      <td>{form.totalAmount ? GCurrency({ value: form.totalAmount }) : '-'}</td>
    </tr>
  )
}

export default MultipleSalesInvoiceDiscountRow
